import React, { useEffect, useState } from 'react';
import styles from '../../business-division.module.scss';

const Banner = ({ bannerText, id, divisionName }) => {
    const [componentIsLoaded, setComponentIsLoaded] = useState(false);

    useEffect(() => {
        // setComponentIsLoaded(true);
    }, []);

    return (
        <div className={styles.bannerContainer}>
            <div className={`${styles.bannerColor} ${styles[id]} ${componentIsLoaded ? styles.bannerLoaded : styles.bannerUnloaded}`}>
                <h1>{divisionName}</h1>
            </div>
            <div
                className={styles.bannerContentContainer}
            >
                <div className={styles.bannerOverlay}></div>
                <div className={`${styles.bannerText} ${styles[id]}`}>
                    <hr className={styles[id]} />
                    <h1>{bannerText}</h1>
                </div>
            </div>
        </div>
    );

};

export default Banner;
